import { memo } from 'react';
import {
  ProjectIcon as SharedProjectIcon,
  type ProjectIconProps,
} from '@trinity/chat-components/components/icons/Project/index.js';
import { useTheme } from '@trinity/chat-components/components/Theme/index.js';
import type { ProjectType } from '@/enums/project';

type Props = {
  projectTypeId: ProjectType;
  style?: React.CSSProperties;
} & ProjectIconProps;

export const ProjectIcon = memo(({ projectTypeId, ...props }: Omit<Props, 'color'>) => {
  const theme = useTheme();

  const color = theme.palette.primary.main;

  return <SharedProjectIcon projectType={projectTypeId} color={color} {...props} />;
});

export default ProjectIcon;
